import { useParams } from 'react-router';
import { z } from 'zod';

export function useStrongParams<T extends z.ZodRawShape>(
  schema: z.ZodObject<T>
) {
  const params = useParams();
  const parsed = schema.passthrough().safeParse(params);
  if (!parsed.success) {
    throw new Error(`Invalid params: ${parsed.error.message}`);
  }

  return parsed.data;
}
